'use strict';
var overlayVideo = require('./../overlay-video.js');

exports.init = function () {
    /** Initialize home page video overlay close and detach on click */
    var params = { 
        containerSelector : '.js-home-video-container', 
        closeButtonSelector : '.js-home-video-container-close'
    };

    overlayVideo(params);


    if(SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
    	$(function() {
    		$("img.hme-unveil-carousel:not(.unveil-loaded)").unveil(100, function() {
	       		$(this).addClass('unveil-loaded');
	        });
        });
    }

};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/storefront.js